// @ts-nocheck
import { isPointInsideFrame, transformPointByMatrix3 } from "../shared/common";
import { mat3 } from "gl-matrix";

/**
 * Виртуальный Объект, который будет представлять собой факт соединения отрезков (участков)
 */
export class Join{
    id: null;
    ownerId: string;
    type: string;
    color: number[];
    active: boolean;
    adjacents: string[];
    route: string[];
    center: any;
    radius: number;
    angleDeg: null;

    
    constructor(point, ownerId) {
        this.id = null;
        this.ownerId = ownerId;
        this.type = 'join';

        this.color = [1,0,1,1];
        
        this.active = false;
        this.adjacents = [];
        this.route = [];
        this.center = point;
        this.radius = 5;

        this.angleDeg = null;
    }

    getVertices() {
        const points = [];
        for (let i = 0; i <= 360; i++) {
            const angle = i * Math.PI / 180;
            const x = this.center.x + this.radius * Math.cos(angle);
            const y = this.center.y + this.radius * Math.sin(angle);
            points.push(x);
            points.push(y);
        }
        return new Float32Array(points);
    }
    getVerticesArray() {
        return [];
    }

    
    isinSelectFrame(frame) {
        if (
            isPointInsideFrame(frame, this.center.x, this.center.y)
        ) {
            return true;
        }

        return false;
    }
    isinSelectFrameAtLeast(frame) {
        if (
            isPointInsideFrame(frame, this.center.x, this.center.y)
        ) {
            return true;
        }

        return false;
    }

    iscrossSelectFrame(frame) {

        return false;
        
    }

    zoom(zl: number):void {
        const zoom_mat = mat3.fromScaling(mat3.create(), ([zl, zl]));
        this.center = transformPointByMatrix3(zoom_mat, this.center);
        this.radius = this.radius * zl;
    }

    pan(tx:number, ty:number):void {
        const pan_mat = mat3.fromTranslation(mat3.create(), [tx, ty]);
        mat3.transpose(pan_mat, pan_mat);
        this.center = transformPointByMatrix3(pan_mat, this.center);
    }


}